import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faInfoCircle, faExclamationTriangle, faBell } from '@fortawesome/free-solid-svg-icons';

function Popup({ type, message, reactElement, onClose, onConfirm }) {
  const getIcon = () => {
    switch (type) {
      case 'error':
        return <FontAwesomeIcon icon={faExclamationCircle} />;
      case 'warning':
        return <FontAwesomeIcon icon={faExclamationTriangle} />;
      case 'message':
        return <FontAwesomeIcon icon={faInfoCircle} />;
      default:
        return <FontAwesomeIcon icon={faBell} />;
    }
  };

  return (
    <div className="pp-overlay">
      <div className={`pp-popup pp-${type}`}>
        <div className="pp-icon-container">
          <div className="pp-icon">{getIcon()}</div>
        </div>
        <div className="pp-content">
          {reactElement || <h2 className="pp-title">{message}</h2>}
        </div>
        <div className="pp-buttons">
          {typeof onConfirm === 'function' && (
            <button className="pp-confirm" onClick={onConfirm}>
              Đồng ý
            </button>
          )}
          <button className="pp-close" onClick={onClose}>
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
}

Popup.propTypes = {
  type: PropTypes.oneOf(['error', 'warning', 'message']).isRequired,
  message: PropTypes.string,
  reactElement: PropTypes.element,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

export default Popup;
